import MailFooter from '../../../public/svg_images/mail-footer.svg';

function MailFooterSvg() {
  return (
    <div className='bg-[#04BBDC] w-[29px] h-[26px] flex items-center justify-center rounded-md'>
    <MailFooter
      width={13}
      height={11}
      role="img" aria-label="Email contact" 
    />
    </div>
  );
}

export default MailFooterSvg;